import { Box } from "@repo/components/src/ui/box";
import { Button, ButtonIcon, ButtonText } from "@repo/components/src/ui/button";
import { Heading } from "@repo/components/src/ui/heading";
import { Icon } from "@repo/components/src/ui/icon";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { RefreshCw, TriangleAlert } from "lucide-react-native";
import React from "react";

type Props = {
  message?: string;
  onRetry: () => void;
  retrying?: boolean;
};

const ErrorState = React.memo(({ message, onRetry, retrying }: Props) => (
  <Box className="flex-1 items-center justify-center">
    <VStack space="lg" className="items-center max-w-md">
      <Box className="w-14 h-14 rounded-2xl bg-brand-50 border border-brand-100 items-center justify-center">
        <Icon as={TriangleAlert} className="text-brand-500" size="lg" />
      </Box>
      <VStack space="xs" className="items-center">
        <Heading size="sm" className="text-typography-900 text-center">
          No pudimos cargar el reporte
        </Heading>
        <Text size="sm" className="text-typography-500 text-center">
          {message ??
            "Ocurrió un error al obtener los datos del reporte. Inténtalo nuevamente en un momento."}
        </Text>
      </VStack>
      <Button
        onPress={onRetry}
        action="brand"
        variant="solid"
        size="md"
        rounded="xl"
        isDisabled={retrying}
      >
        <ButtonIcon as={RefreshCw} />
        <ButtonText>{retrying ? "Reintentando..." : "Reintentar"}</ButtonText>
      </Button>
    </VStack>
  </Box>
));

ErrorState.displayName = "ReportErrorState";

export default ErrorState;
